module.exports = __webpack_public_path__ + "static/media/twitter.b8e276b2.svg";